// aplicarCupom.js
export default async function aplicarCupom(cupom, planoSelecionado, erroCupom, cupomValido) {
  if (!cupom.value || !planoSelecionado.value) {
    erroCupom.value = 'Você precisa selecionar um plano e informar o cupom.'
    return
  }

  try {
    const res = await fetch(`${import.meta.env.VITE_API_BASE_URL}/api/cupons/codigo/${cupom.value}`)
    const data = await res.json()

    if (!data || !data.codigo) {
      erroCupom.value = 'Cupom inválido.'
      cupomValido.value = null
      return
    }

    const hoje = new Date()
    const inicio = new Date(data.dataInicio)
    const fim = new Date(data.dataFim)

    if (hoje < inicio || hoje > fim) {
      erroCupom.value = 'Cupom vencido ou ainda não está disponível.'
      cupomValido.value = null
      return
    }

    // Valida se o cupom é específico para um plano
    if (data.plano && data.plano.id !== planoSelecionado.value.id) {
      erroCupom.value = `Cupom válido apenas para o plano ${data.plano.nome}.`
      cupomValido.value = null
      return
    }

    // Tudo certo
    erroCupom.value = ''
    cupomValido.value = data

  } catch (e) {
    console.error('Erro ao aplicar cupom:', e)
    erroCupom.value = 'Erro ao validar o cupom.'
    cupomValido.value = null
  }
}
